import { createPortal } from 'react-dom';

/**
 * Renders layer + backdrop + dialog into a portal container (scroll-lock lives on useModalPortal).
 *
 * @param {{
 *   portalEl: HTMLElement,
 *   dialogRef: import('react').RefObject<HTMLDivElement|null>,
 *   layerClassName: string,
 *   backdropClassName: string,
 *   dialogClassName: string,
 *   dialogProps: import('react').HTMLAttributes<HTMLDivElement>,
 *   children: import('react').ReactNode,
 *   afterDialog?: import('react').ReactNode,
 * }} props
 */
export default function FullscreenModalFrame({
    portalEl,
    dialogRef,
    layerClassName,
    backdropClassName,
    dialogClassName,
    dialogProps,
    children,
    afterDialog = null,
}) {
    return createPortal(
        <div className={layerClassName}>
            <div className={backdropClassName} aria-hidden='true' />
            <div ref={dialogRef} className={dialogClassName} {...dialogProps}>
                {children}
            </div>
            {afterDialog}
        </div>,
        portalEl
    );
}
